import { createNavigator } from "single-spa/react-app/router/utils/BaseNavigator";

import { ROUTES } from "./publisherAnalysisConstants";
import type { PublisherAnalysisParamKeys } from "./publisherAnalysisRoutes.types";

export const publisherAnalysisNavigation = createNavigator<PublisherAnalysisParamKeys, typeof ROUTES>(ROUTES);
